import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AdsenseBanner from 'components/features/google-ads/google-ads';

import { findCurrentLoan } from 'store/actions/customer-actions';

import routes from 'resources/routes.json';

import styles from './styles.modules.scss';
import { FormSelect, FormText } from '../../../components/UI/form';
import { BANK_LIST } from '../../../utils/enumerator/enum-bank-code';
import { APPLICATION_CONDITIONS_SELECTED, APPLICATION_CONTRACT_READY } from '../../../utils/enumerator/enum-loan-state';
import Button from '../../../components/UI/button/button';
import { addBankMask } from '../../../utils/helper/formatting';
import { CORRECT_BANK_ACCOUNT_SUCCESS, correctBankAccount } from '../../../store/actions/loan-actions';
import ErrorNotification from '../../../components/features/error-notification/error-notification';
import { goToLoanRoute } from '../../../navigation/application-routes';

function DeclinedBankComponent({ title, onSuccessUpdate, withAdd = true }) {
  const dispatch = useDispatch();
  const loan = useSelector((state) => state?.personalLending?.loan);
  const device = useSelector((state) => state?.customer?.device);

  const [bankCode, setBankCode] = useState(null);
  const [bankBranch, setBankBranch] = useState(null);
  const [bankAccountNumber, setBankAccountNumber] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [validation, setValidation] = useState({
    initialized: false,
    bankCode: false,
    bankBranch: false,
    bankAccountNumber: false,
  });

  useEffect(() => {
    dispatch(findCurrentLoan(device));
  }, []);

  function getFirstName() {
    if (loan?.application) {
      return loan?.application?.personal?.name ? loan?.application?.personal?.name?.split(' ')[0] : 'Cliente';
    }

    return 'Cliente';
  }

  function onChangeBankCode(value, valid = false) {
    const validationChangeBankCode = { ...validation, bankCode: valid };
    setValidation(validationChangeBankCode);
    setBankCode(value);
  }

  function onChangeBankBranch(value, valid = false) {
    const validationChangeBankBranch = { ...validation, bankBranch: valid };
    setValidation(validationChangeBankBranch);
    setBankBranch(value);
  }

  function onChangeBankAccountNumber(value, valid = false) {
    const validationChangeBankAccountNumber = { ...validation, bankAccountNumber: valid };
    setValidation(validationChangeBankAccountNumber);
    setBankAccountNumber(value);
  }

  function formatBankAccount(value) {
    return addBankMask(value);
  }

  function updateBankInformationClick() {
    setValidation({ ...validation, initialized: true });
    setLoading(true);
    setErrors([]);

    if (validation.bankAccountNumber && validation.bankBranch && validation.bankCode) {
      dispatch(
        correctBankAccount(bankCode, bankBranch, bankAccountNumber.split('-')[0], bankAccountNumber.split('-')[1]),
      ).then((response) => {
        if (response.type === CORRECT_BANK_ACCOUNT_SUCCESS) {
          if (onSuccessUpdate) {
            onSuccessUpdate();
          } else {
            dispatch(findCurrentLoan(device)).then(({ payload: currentLoan }) => {
              goToLoanRoute(currentLoan, routes.LOAN_DECLINED_BANK, routes.LOAN_APPlICATION);
            });
          }
        } else {
          setErrors(['Erro ao atualizar dados. Verifique e tente novamente.']);
        }
        setLoading(false);
      });
    } else {
      setErrors([]);
      setLoading(false);
    }
  }

  const DAY_LIST = [];
  for (let i = 1; i < 32; i++) DAY_LIST.push(i);

  return (
    <div id="main-content" className={styles.declinedContainer}>
      {loan && loan.id && (
        <div className={styles.declinedBankWrapper}>
          <h2 className={styles.title}>
            {title || `${getFirstName()}, seu banco não é compatível. Você tem conta em outro banco?`}
          </h2>

          <div id="form-area">
            <ErrorNotification errors={errors} />

            <div className="row mt-4 d-flex justify-content-center p-2">
              <div className="col-lg-12" style={{ color: '#2a2b35' }}>
                <FormSelect
                  id="bankCode"
                  className=""
                  label="Seu banco"
                  mandatory
                  initialized={validation.initialized}
                  maskPattern="[0-9]{0,3}"
                  contentPattern="[0-9]{0,3}"
                  validationPattern="[0-9]{1,3}"
                  validationMessage="O banco deve ser informado"
                  value={bankCode}
                  onChange={onChangeBankCode}
                >
                  <option value=""> </option>
                  {BANK_LIST.filter((bank) => bank.active).map((bank) => (
                    <option key={bank.code} value={bank.code}>
                      {bank.name}
                    </option>
                  ))}
                </FormSelect>

                <FormText
                  id="bankBranch"
                  label="Sua agência (sem dígito)"
                  mandatory
                  initialized={validation.initialized}
                  maskPattern="[0-9]{0,5}"
                  contentPattern="[0-9]{0,5}"
                  validationPattern="[0-9]{1,5}"
                  validationMessage="Agência inválida"
                  value={bankBranch ?? ''}
                  onChange={onChangeBankBranch}
                />

                <FormText
                  id="bankAccountNumber"
                  label="Sua conta (com dígito)"
                  mandatory
                  initialized={validation.initialized}
                  formatFunction={formatBankAccount}
                  validationPattern="[0-9]{4,11}\-[0-9a-zA-Z]"
                  validationFunction={() => true}
                  validationMessage="Conta corrente inválida. Exemplo: 13002-4"
                  value={bankAccountNumber ?? ''}
                  onChange={onChangeBankAccountNumber}
                />

                <div className="d-flex justify-content-center">
                  <Button
                    width="140px"
                    height="39px"
                    rounded
                    onClick={updateBankInformationClick}
                    disabled={loading}
                    loading={loading}
                  >
                    Atualizar
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {withAdd && (
            <>
              <div className={`${styles.bannerContainer} col-12 col-md mb-3`}>
                <a
                  id="declinedPageMultiplikBanner"
                  target="_blank"
                  href="https://www.supersim.com.br/multiplik?utm_source=supersim&utm_medium=negado&utm_campaign=default-adsense"
                >
                  <img alt="Banner da Multiplik" src="/image/img_multiplik_oferta.png" />
                </a>
              </div>
              <AdsenseBanner
                dataAdSlot="3519981606"
                url="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7355366967203449"
              />
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default DeclinedBankComponent;
